module.exports = __webpack_public_path__ + "static/Contact_Parallax-optimized-35f0fe223f92770667873d07334d3993.jpg";